import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";
import { MessageCircle, Sparkles } from "lucide-react";
import ButtonMain from "@/components/buttons/button_main";
import ButtonGhost from "@/components/buttons/button_ghost";

export default function MatchModal({ open, renter, onClose }) {
  return (
    <AnimatePresence>
      {open && renter && (
        <motion.div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-brand-ink/70 p-4 backdrop-blur-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div
            className="w-full max-w-sm rounded-3xl bg-night-surface p-8 text-center shadow-2xl"
            initial={{ scale: 0.8, y: 30, opacity: 0 }}
            animate={{ scale: 1, y: 0, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ type: "spring", stiffness: 260, damping: 22 }}
            onClick={(e) => e.stopPropagation()}
          >
            <motion.div
              initial={{ rotate: -10, scale: 0 }}
              animate={{ rotate: 0, scale: 1 }}
              transition={{ delay: 0.15, type: "spring", stiffness: 300 }}
              className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-night-tint"
            >
              <Sparkles className="h-7 w-7 text-brand-primary" />
            </motion.div>

            <h2 className="text-2xl font-extrabold text-night-text">It is a match</h2>
            <p className="mt-1 text-sm text-night-sub">
              {renter.name} already liked your listing. Say hello and get the conversation going.
            </p>

            <div className="mx-auto mt-6 h-24 w-24 overflow-hidden rounded-full ring-4 ring-night-tint">
              <img src={renter.photo} alt={renter.name} className="h-full w-full object-cover" />
            </div>
            <p className="mt-3 font-bold text-night-text">
              {renter.name}, {renter.age}
            </p>

            <div className="mt-6 space-y-3">
              <Link to="/matches" className="block">
                <ButtonMain full onClick={onClose}>
                  <span className="inline-flex items-center gap-2">
                    <MessageCircle className="h-4 w-4" /> Open chat
                  </span>
                </ButtonMain>
              </Link>
              <ButtonGhost full onClick={onClose}>
                Keep browsing
              </ButtonGhost>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
